<template>
    <div class="bg_eef1fa detail web_detail">
        <div class="main flex_space_between align_items_flex_start">
            <div class="left">
                <div class="swiper-container left_container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in detail.img">
                            <img :src="item" />
                        </div>
                    </div>
                    <div class="swiper-button-prev left_prev"></div>
                    <div class="swiper-button-next left_next"></div>
                </div>
                <div class="detail_box flex_start">
                    <img :src="detail.pic"/>
                    <div class="detail_box_text">
                        <h2>{{detail.title}}</h2>
                        <div class="detail_box_rule flex_start">
                            <em>尺寸；{{detail.img_info}}</em><em>大小：{{detail.img_size}}K</em><em>格式：{{detail.img_ext}}</em>
                        </div>
                        <p class="flex_start flex_wrap">
                            <span v-for="(item,index) in detail.flag">{{item}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="swiper-container vertical_container" v-if="likelist.length > 0">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" style="height:72px;" v-for="(item,index) in likelist" @click="goUrl(this,item.id,item.type)">
                            <img :src="item.pic" />
                        </div>
                    </div>
                </div>
                <div class="swiper-button-prev vertical_prev" v-if="likelist.length > 0"></div>
                <div class="swiper-button-next vertical_next" v-if="likelist.length > 0"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        data(){
            return {
                id: 0,
                detail:[],
                likelist: [],
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.$http({
                url: 'index/article',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data:{type:'pic',id:this.id}
            }).then(res => {
                if(res.data.code == 1) {
                    this.detail = res.data.data.detail;
                    this.likelist = res.data.data.like;
                    this.$nextTick(() => {
                        new Swiper(".vertical_container", {
                            direction: 'vertical',
                            loop:true,
                            autoplay: 3000,
                            slidesPerView: 'auto', // 设置可视区一共显示几张图片,设置auto,设置auto为自适应;
                            // spaceBetween:27, //  每张图片之间的间隔
                            nextButton: '.vertical_next',
                            prevButton: '.vertical_prev',
                        });
                        new Swiper(".left_container", {
                            autoplay: 3000,
                            loop:true,
                            nextButton: '.left_next',
                            prevButton: '.left_prev',
                        });
                    });
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        watch: {
            $route() {
                location.reload();
            },
        },
        mounted() {

        },
        methods:{
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            }
        },
    }
</script>

<style scoped>
    .detail{padding:45px 0 60px;}
    .right{width: 218px;max-height:800px;background:#fff;padding:76px 45px 45px;position: relative;}

    .vertical_container.swiper-container {width: 100%;height: 100%;max-height: 693px;}
    .vertical_container .swiper-slide {text-align: center; /* Center slide text vertically */display: -webkit-box;display: -ms-flexbox;display: -webkit-flex;display: flex;-webkit-box-pack: center;-ms-flex-pack: center;-webkit-justify-content: center;justify-content: center;-webkit-box-align: center;-ms-flex-align: center;-webkit-align-items: center;align-items: center;}
    .vertical_container .swiper-slide{width:128px;height: 99px !important;padding-bottom:27px;}
    .vertical_container .swiper-slide img{width:100%;height:100%;object-fit: cover;display: block;border-radius: 5px;overflow: hidden;}
    .vertical_prev,.vertical_next{opacity: 1 !important;background-size: contain;background-repeat: no-repeat;width: 64px;height: 25px;}
    .vertical_prev{top:65px;left:50%;transform:translateX(-50%);background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAnJJREFUaEPtmFFuwjAMhu1yoE0C+go7yXaDsZOM3aA9ycprodJ2IJrJUzahNklJaoeqpNJeBkn9+bf9kyDc2YN3xgsJeO6KJ4WTwjPLQCrpmQnaw0kKJ4VnloFU0jMT9PZD63Q6qcsoVqtV1CqL9rKmaV6UUs8AsO2kvULEcrlcFjGqKwpwXdebLMteAID+TE/Rtm2R5/lBGjoKcLeMbVAxylsUuK7rxyzL3g1lbGOu2rZ9y/P8S0ppMWDdsxtLGZcaiHq6+xSIeJDqaUngSilFwL1HKfVE/0TET9PnGrg73FhEFwF29Wy3T32+y0HMCuywHoq1VEoV6/W6ugz8eDxuEZGmt6m82S2LDVgPqFdTz1KJAkBh60tKFK2ztABZ1gfXIGMDbprG2rPX2o2tvDl7ejSwLkm24eNKHA27bkv49vUo4CHrQcTK1170njShRSxrLLDTekLV4K6ayyoIBo5hJxLv8AYOsR7fPvv7voRleQG7rAcAvhFx79uzQ8nQCd4BwIPpZ6ivZXkBS09QGzxnT18FzPnCIUVdn3MkfBBYwnpCoTks6xpgEesJhR5bbU5gCVsIBe2uC43NCBzTekITEGpZPeBbWE8odIhl9YA5JmEoQMg6357+B/ZdGBKc5JprhfoF1rB0OjHdG5chpx5JONPeQ5allCrpMIOuS3I6eJ/P5x3XbYN0Emj+LBaLvePmpMDQ8S4d/Jj9XUw2YOOF25ggYq51WZYJWOTUExOY3mWzrB4wx71RbDifU9bgb+mpBM8VRwLmyuRU90kKT1UZrriSwlyZnOo+SeGpKsMVV1KYK5NT3ScpPFVluOK6O4V/ADhcrnVNEG7+AAAAAElFTkSuQmCC");}
    .vertical_next{top:calc(100% - 35px);left:50%;transform:translateX(-50%);background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAphJREFUaEPtmVFy4yAMhiUutDvjxK/pnmR7hPYGvUF7BOckm7w68cz2Qqgj1844NmBDgRAHv8YGffqFfiAID/bgg/FCBl674lnhrPDKMpBLemWCTnCywlnhlWUgl/TKBM1N6/FK+nw+01B3Ivqz3W4Payjt0+n0hIj/hiw4BgaAioj29w7dwf4FgOc5YP69klJWZVke71Hpuq53QggGvYJlFpXCF8bNZnOXa1xRtRcm7KTnTLD84+cgpXwty/L/PShd1/VvIcQ7ADwp4t0TUdUq2DTNMxG9AMAvxYsvUspj6tAd7A4APhQMn4j4URTFNzA/qo7W/4aIx6IoVFlLRvimaQ5ExMCTZ+g8kzW69MNUSG2FUgG33U2TraQsS2c9bTdGZIepuIyvbEmlFK9pE3QKlmW0Hg1smwhTaZra+60tyzU2I3BXMtz1VN37JpY1Yz2f7DamXeLsxqKzLO7QKp+uug5+tU5CNbQuFu7Ekx0UAOwR8TBes+NYZoFTsiwfDrIIuM+Sjwld1Le1HtMctsDRLcvFerwB99vQWJblaj1egfvBXG3BpqRDzGFV0sNgQ1rWT60niMJ9eRORV8vyYT3BgENYVmgncC7pcRZNgS7dhurWrM/jqU9grWUh4htfIui2fNwPhBA7Inqb7IwMBwGbBng527t8pPvG5ZQVwnqCrmHV4DZ2YvOuD3G8lbStZfH7hgu32VOPK3wQ4CWW1QXsfOpJDnjOsnQBh/6rJ5jCQyDTOh2+t9S+XNXl76IAz1z2cxztJXmM/7OiAJtOWbrbxZ+oGN2WTBOOyztGGQ/jiaZwPymX9zCAGGV8U+BQpbp03OgKLw0s1HsZOFRmUxk3K5yKEqHiyAqHymwq42aFU1EiVBwPp/AX0B63ec0NtVsAAAAASUVORK5CYII=");}

    .left{width:915px;padding:78px 75px 25px;background: #fff;}
    .left .swiper-container {width: 100%;height: 100%;max-height: 513px;}
    .left .swiper-slide{width:100%;height:100%;border-radius: 10px;overflow: hidden;}
    .left .swiper-slide img{width: 100%;height: 100%;object-fit: cover;display: block;}
    .left_prev,.left_next{width: 47px;height: 93px;text-align: center;background-size: 26px auto;background-position: center;background-repeat: no-repeat;background-color: #34488b;margin-top:0;transform: translateY(-50%);}
    .left_prev{left:0;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAoZJREFUaEPlm1FSwjAQhjfvdNQbcARuAJ5AX8UH9QbUCwgniJcAjmG5AdzEGTqDzhTipFWmlLZD0k12bXnigbb5svvnT3aLgH/wkYtYnQxTqNvwIYhshi5sLvJ1jVzu+gDJEygxbT2wnMcDBTAUAt7PJriNEZaLWKfssDSb2gYsF/EHAAwA4LosuvCVrMOXm08babHSsFxuR2lUi5rNyFagVBQ+Bqd6NqTmBTzfTkGIt1IGpWZNYfV92QDXaTYc99DGiXYjw8w6/lyvxiBAVmh2A0JNbD23bEykwLXWA7ABgCgc9ya2k8kP2JH11E0QWYRdWg8rYB/WwwvYg/WwAXa1XTRZ1Lxo+BLrabJdZAVMYT2kKc0hjfMT4DSlqazHe4Sprcc/MLH1eAXmptkiPJqGOVmP8wjr6qI67O9KC26OTj0m3ou+Sss6zTYouNlCOY3wWZE89zTMSgUWvLWGOVuPkwjXpjFSwQ0rqo01zN160CNcAZwW3Hydemyjb6XhCuC1AjUR38nGtitgC2FyHSZw9lxmNoS20+rUoqVnLbWlA4wqWiMRCBWFD8HMJN18/NYqpfMD68zG4wS6S1vLLL13fVD7e/21JC3XutWJ3TKxTf/GKf334N/joX49QTeyrwoDYmNZaMBHcIJ+kUm00YHTFO9SiYe7ZTmJcCG9yzQNCtSIYhvqFDiNNjNNuwfOXmnQb+ewsCznwNkilkKzsCwvwJwsyyswB8vyD0x8yvIOTG1ZZMBUlkULTGBZpMCXWtbrOFiZHBDQy7RYDy9UTipfCMds2ZBH+OLKCVI3gxewB8tiBezDslgCu7QsvsB1ltWgu8EW+FgNPSTPZ8X+tgLnNI32V7wfeQO7TNbYiaMAAAAASUVORK5CYII=");}
    .left_next{right:0;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAmhJREFUaEPlm91RwkAQx/cgM+pMmKET6AAsA2iCqwBowNgB+iC8agVCB5RgB+iE93MSo2ZCPo/bD2OeE+5+2d373/03KLC8gm04BqNe04/rqa8sf47sMesJ5gGDMksA71FPbt7ICBoO5BYYAIyBuQLY65l/aDgXktudAyez3uupPyYhaDiIPfD62Idrb5it42T8dwA46Kl/23A+6LdbA3/PLHgKl6BUFM3R2Wzjmoa9nvR26CQ1B7gYOBongV7kjmnMSs96EbiIywnwT7Q3J1NAJaam3QJ/afM9AAwy4HFNgwHNvXo7BY7Te3OKgKOazkKLkCznwDF0zi4sFXHW9MYBFixZKMCSJQsVWKJkoQNLq2ka4N+aZpcsEuDUxoRdskiBJaQ3PTCzZJEDc0sWGzCXZLECc9Q0PzCxZLED15asTvfFhRsqBrgyvR05J6KAazgncKnZLxMY0RgUCYwpWWKBK2s6sn8tzH7ZwOWS1U5gc+UNFMRO6DDjhLYQGMEMFJvSWN0MkcDBNlyAiftV5x1IY1bQgZ1tv0omcHHLpl0bj1IDv21by6RFE7Vcs6txtDhrUN3nVhwegvWxXyI9H0kTbu6qCcdew9R9KFZgLOkp67yzAWNKjyjgVM3mffcR16zNoaDu9xTkEaau2eyLIAWulB4DO1ercVHESYCppYe9hrnTOP0C0CPMIT1sEeaSHnJgbumhB0ZwKurqbNV9zmtYgvSQRfhuE44KDDfnp56qSJLocPBfPi6VJj2oKS1RelCAJUsPDrBg6aEG1kBw6iFfpXMPBLFJ7j24cBdtgaqes954/NW/4n0CjiulTA6/vQQAAAAASUVORK5CYII=");}

    .detail_box{width:100%;margin-top:25px;}
    .detail_box img{width: 129px;/*height: 155px;*/height:100%;min-height:155px;object-fit: cover;display: block;margin-right: 20px;}
    .detail_box_text{width:calc(100% - 150px);display: block;}
    .detail_box_text h2{width:100%;color:#000;font-size:24px;line-height: 40px;display: block;}
    .detail_box_text_intro{width: 100%;font-size:14px;line-height: 32px;color:#000;margin-bottom: 20px;}
    .detail_box_text_intro i{font-weight: bold;}
    .detail_box_rule{width: 100%;font-size:14px;line-height: 26px;margin-bottom: 5px;color:#000;}
    .detail_box_rule em{font-style: normal;margin-right: 25px;}

    .detail_box_text p{width: 100%;padding-bottom: 11.5px;}
    .detail_box_text p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 3px;}


    @media screen and (max-width: 1920px) {
        .detail{padding:3.629vw 0 2.8225vw;}
        .web_detail .right{display: none;}
        .web_detail .left{width:96%;margin:0 auto;padding:6.29vw 6.048vw 2.016vw;}
        .left .swiper-container, .left .swiper-container .swiper-wrapper, .left .swiper-container .swiper-wrapper .swiper-slide{max-height: 653px;}
    }
    @media screen and (max-width: 640px) {
        .detail_box{margin-top:3.90625vw;}
        .web_detail .left{padding:2vw;}
        /*.detail_box img{display: none;}
        .detail_box_text{width:100%;}*/
        .detail_box_text h2{font-size:20px;line-height: 30px;}
        .detail_box_text_intro{font-size:14px;line-height: 18px;margin:1vw 0;}
        .detail_box_rule em{margin-right: 2vw;white-space: nowrap;}
        .detail_box_text p span{margin-right: 2vw;border-radius: 5px;}
        .left_prev,.left_next{width: 3.7903vw;height: 7.5vw;background-size:2.09677vw auto;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/pic/detail.vue